import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import Image from 'components/image/Image';
import OrganizationCulture from 'components/feature/organizationCulture';
import { CMSService } from 'services/cms/cms';
import { IMe } from 'core/interface/me';
import { callForAllElement } from 'helpers/callAll';
import { useParams } from 'react-router';
import useLocales from 'hooks/useLocales';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PopUpWrapper from 'components/PopUpWrapper';

function Organization({ canEdit }: { canEdit: boolean }) {
  const [openModal, setOpenModal] = useState(false);
  const { cms } = useSelector((state: RootState) => state.cms);
  const me = useSelector((state: IMe) => state.user).user;
  const { id } = useParams();
  const { t } = useLocales();

  const handleModal = () => {
    setOpenModal(!openModal);
  };

  const handleChange = (companyData: any) => {
    callForAllElement(companyData, (image) => {
      const formData = new FormData();
      formData.append('image', image);
      return CMSService.updateCMSGallery(me?.company, formData, 'gallery');
    });
    handleModal();
  };

  return (
    <div>
      {cms?.gallery?.length > 0 && (
        <div className="organizationalContainer">
          <div className="organizationalContainer_first">
            <h1 style={{ marginBottom: '20px', minWidth: '50%' }}>
              {t('Our organizational culture')}
            </h1>
            {canEdit && (
              <div className="pencil_icon" onClick={handleModal}>
                <div className="pencil_circle" />
                <Image
                  className="pencil"
                  name="pencil.svg"
                  width={13}
                  height={13}
                />
              </div>
            )}
          </div>
          <div>
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={2}
              slidesToScroll={1}
              arrows={true}
              className="organization-carousel"
            >
              {cms?.gallery?.map((item: any, idx: number) => (
                <div key={item.id}>
                  <div className="aspect-ratio-box">
                    <img src={item.image} alt={t('Organization gallery')} />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
      {openModal && (
        <PopUpWrapper onClick={handleModal}>
          <OrganizationCulture
            companyData={cms}
            isOneBtn={true}
            setNewData={handleChange}
            onClose={handleModal}
            showTitle
            showTopSide={false}
            isPopup={true}
          />
        </PopUpWrapper>
      )}
    </div>
  );
}

export default Organization;
